import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles, AlertTriangle } from "lucide-react";

export default function TrialBanner() {
  const { user } = useAuth();
  const trial = user?.trial;
  if (!trial) return null;

  // Paid subscription — no banner
  if (trial.status === "paid") return null;

  const daysLeft = trial.days_left ?? 0;

  if (trial.status === "expired") {
    return (
      <div className="bg-red-500/10 border-b border-red-500/30 px-4 py-2 flex flex-wrap items-center justify-between gap-3" data-testid="trial-banner-expired">
        <div className="flex items-center gap-2 text-sm">
          <AlertTriangle className="h-4 w-4 text-red-500 shrink-0" />
          <span className="font-medium">Your 14-day free trial has ended.</span>
          <span className="text-muted-foreground hidden sm:inline">Upgrade to keep using AI features.</span>
        </div>
        <Link to="/app/subscription" data-testid="trial-upgrade-btn"
          className="btn-sharp mono text-[10px] uppercase tracking-widest bg-red-500 text-white px-3 py-1.5 hover:opacity-90">
          Upgrade now
        </Link>
      </div>
    );
  }

  // Trial active
  const isUrgent = daysLeft <= 3;
  return (
    <div className={`${isUrgent ? "bg-amber-500/10 border-b border-amber-500/30" : "bg-primary/5 border-b border-primary/20"} px-4 py-2 flex flex-wrap items-center justify-between gap-3`} data-testid="trial-banner-active">
      <div className="flex items-center gap-2 text-sm">
        <Sparkles className={`h-4 w-4 shrink-0 ${isUrgent ? "text-amber-500" : "text-primary"}`} />
        <span className="font-medium">
          {daysLeft === 0 ? "Trial ends today" : daysLeft === 1 ? "1 day left in trial" : `${daysLeft} days left in your free trial`}
        </span>
      </div>
      <Link to="/app/subscription" data-testid="trial-upgrade-link"
        className="mono text-[10px] uppercase tracking-widest hover:text-primary underline">
        Upgrade →
      </Link>
    </div>
  );
}
